import React from "react";
import QRCode from "qrcode";
import { saveAs } from "file-saver";
import { Button } from "reactstrap";
import { RiQrCodeLine } from "react-icons/ri";

const RoomQRCode = ({ room }) => {
  const downloadQR = async () => {
    try {

      const tenantId =
        localStorage.getItem("user")
          ? JSON.parse(localStorage.getItem("user")).tenantId
          : "";

      const qrUrl =
        `${window.location.origin}/guest-portal/${tenantId}/${room.roomNumber}`;

      const qrDataUrl = await QRCode.toDataURL(qrUrl, {
        width: 500,
        margin: 1,
      });

      const canvas = document.createElement("canvas");
      canvas.width = 900;
      canvas.height = 1200;

      const ctx = canvas.getContext("2d");

      // Background
      ctx.fillStyle = "#f8fafc";
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      // Main Card
      ctx.fillStyle = "#ffffff";
      roundRect(
        ctx,
        40,
        40,
        820,
        1120,
        30,
        true
      );

      // Header
      ctx.fillStyle = "#0d6efd";
      roundRect(
        ctx,
        70,
        70,
        760,
        120,
        20,
        true
      );

      ctx.fillStyle = "#ffffff";
      ctx.font = "bold 42px Arial";
      ctx.textAlign = "center";

      ctx.fillText(
        `ROOM ${room.roomNumber}`,
        450,
        125
      );

      ctx.font = "24px Arial";

      ctx.fillText(
        room.roomType?.name || "Room",
        450,
        165
      );

      // QR Image
      const qrImage = new Image();

      qrImage.onload = async () => {
        ctx.drawImage(
          qrImage,
          200,
          250,
          500,
          500
        );

        // Text
        ctx.fillStyle = "#198754";

        ctx.font = "bold 34px Arial";

        ctx.fillText(
          "Order Any Service or Item",
          450,
          840
        );

        ctx.fillStyle = "#0d6efd";

        ctx.font = "28px Arial";

        ctx.fillText(
          "Scan Here",
          450,
          890
        );

        ctx.fillStyle = "#64748b";

        ctx.font = "22px Arial";

        ctx.fillText(
          "Food • Housekeeping • Laundry",
          450,
          970
        );

        ctx.fillText(
          "Spa • Concierge • Checkout Request",
          450,
          1010
        );

        ctx.fillStyle = "#94a3b8";

        ctx.font = "18px Arial";

        ctx.fillText(
          "Powered by Hotel Guest Services",
          450,
          1090
        );

        canvas.toBlob((blob) => {
          saveAs(
            blob,
            `Room-${room.roomNumber}-QR-Card.png`
          );
        });
      };

      qrImage.src = qrDataUrl;
    } catch (err) {
      console.error(err);
    }
  };

  const roundRect = (
    ctx,
    x,
    y,
    width,
    height,
    radius,
    fill
  ) => {
    ctx.beginPath();

    ctx.moveTo(x + radius, y);

    ctx.lineTo(x + width - radius, y);

    ctx.quadraticCurveTo(
      x + width,
      y,
      x + width,
      y + radius
    );

    ctx.lineTo(
      x + width,
      y + height - radius
    );

    ctx.quadraticCurveTo(
      x + width,
      y + height,
      x + width - radius,
      y + height
    );

    ctx.lineTo(x + radius, y + height);

    ctx.quadraticCurveTo(
      x,
      y + height,
      x,
      y + height - radius
    );

    ctx.lineTo(x, y + radius);

    ctx.quadraticCurveTo(
      x,
      y,
      x + radius,
      y
    );

    ctx.closePath();

    if (fill) ctx.fill();
  };

  return (
    <Button
      color="info"
      size="sm"
      onClick={downloadQR}
    >
      <RiQrCodeLine size={15} className="me-1" />
      QR
    </Button>
  );
};

export default RoomQRCode;